import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import {RxdbCmcProtocolRepository} from "../../rxdb/repositories/rxdb-cmc-protocol.repository";
import {from} from "rxjs";
import {CmcProtocol} from "../../models/cmc/cmc-protocol.model";
import {TranslateService} from "@ngx-translate/core";
import {CmcProtocolService} from "./cmc-protocol.service";

@Injectable()
export class OfflineCmcProtocolService extends CmcProtocolService {

    API_URL = '/apiClientManager/v1';

    constructor(
        private rxdbCmcProtocolRepository: RxdbCmcProtocolRepository,
        private http: HttpClient,
        protected translateService: TranslateService) {
        super(translateService);
    }

    searchProtocols(countryIsoCode: string, userRole: string,  pageable: Map<string, string>, searchParam: string) {
        let params = new HttpParams()
            .set('countryIsoCode', countryIsoCode);

        if (searchParam) {
            params = params.set('searchParam', searchParam);
        }
        pageable.forEach((value, key) => params = params.set(key, value));

        return from(this.rxdbCmcProtocolRepository.searchPagedCmcProtocols(countryIsoCode, userRole, pageable, searchParam));
    }

    getCmcProtocol(cmcCode: string, countryIsoCode: string, role: string) {
        const url = `${this.API_URL}/cmc-protocols/${cmcCode}/${countryIsoCode}/${role}`;
        return this.http.get<CmcProtocol>(url);
    }

}
